import { render, staticRenderFns } from "./DraftMusicReview.vue?vue&type=template&id=063c575b&"
import script from "./DraftMusicReview.vue?vue&type=script&lang=js&"
export * from "./DraftMusicReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports